import React from "react";
import { Spin } from "antd";

const CircularProgress = ({ className }) => (
  <div className={`loader ${className}`}>
    <Spin />
  </div>
);
export default CircularProgress;
